var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExemptEntities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 70,
    viewBox: "0 0 77 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_881_98393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0897 38.4558C60.0897 38.4558 59.6561 44.0141 54.1853 44.0141C52.751 43.9194 51.3983 43.3056 50.3749 42.2849C49.3515 41.2641 48.7258 39.9049 48.6124 38.4558",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4211 38.4558C48.4211 38.4558 47.9748 44.0141 42.5039 44.0141C41.0515 43.9435 39.6743 43.3403 38.6298 42.3173C37.5854 41.2943 36.9452 39.9216 36.829 38.4558",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7015 38.4558C36.7015 38.4558 36.2552 44.0141 30.7843 44.0141C29.3342 43.9405 27.96 43.3359 26.9182 42.3132C25.8764 41.2905 25.238 39.9195 25.1222 38.4558H71.7201C71.7201 38.4558 71.2737 44.0141 65.8029 44.0141C64.3438 43.9527 62.9573 43.3536 61.9048 42.3297C60.8524 41.3058 60.2068 39.9279 60.0897 38.4558",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1883 25.1471H62.4362C63.0093 25.1487 63.5717 25.3034 64.0667 25.5955C64.5616 25.8877 64.9714 26.3069 65.2545 26.8107L71.7201 38.4172H25.1222",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5144 43.3951V65.8214C28.5144 66.6708 28.8472 67.4856 29.4399 68.0874C30.0327 68.6893 30.8371 69.0291 31.677 69.0325H65.0505C65.4675 69.0325 65.8804 68.9494 66.2656 68.7881C66.6509 68.6267 67.001 68.3902 67.2958 68.092C67.5907 67.7938 67.8246 67.4398 67.9842 67.0502C68.1437 66.6606 68.2259 66.2431 68.2259 65.8214V43.7303",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9887 69.0325V43.9754",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5144 63.3195H54.9887",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2148 57.3873L41.7643 49.8431",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2148 51.7388L36.1404 49.8431",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0897 38.4559L57.5392 25.1471",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.829 38.4559L39.1883 25.1471",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6124 38.4559V25.1471",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7863 69.0325H76.0432",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4037 34.8192C11.2622 34.8192 3.82539 27.2987 3.82539 18.0542C3.82539 8.81117 11.2622 1.28931 20.4037 1.28931C29.5453 1.28931 36.9821 8.81117 36.9821 18.0542C36.9821 27.2987 29.5453 34.8192 20.4037 34.8192Z",
    stroke: "#059BD2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3305 9.02698V27.0815H11.4769V9.02698L13.9319 10.0841L16.1102 9.02698L18.3614 10.0841L20.517 9.02698L22.7917 10.0841L24.9238 9.02698L27.2212 10.0841L29.3305 9.02698Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 34.4596,
    y2: -0.75,
    transform: "matrix(0.703139 -0.711053 0.703139 0.711053 8.92642 30.9503)",
    stroke: "#059BD2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6285 15.475C18.6285 16.6286 17.7052 17.5542 16.578 17.5542C15.4508 17.5542 14.5275 16.6286 14.5275 15.475C14.5275 14.3214 15.4508 13.3958 16.578 13.3958C17.7052 13.3958 18.6285 14.3214 18.6285 15.475Z",
    stroke: "#059BD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.28 20.6334C26.28 21.7871 25.3567 22.7127 24.2295 22.7127C23.1023 22.7127 22.179 21.7871 22.179 20.6334C22.179 19.4798 23.1023 18.5542 24.2295 18.5542C25.3567 18.5542 26.28 19.4798 26.28 20.6334Z",
    stroke: "#059BD2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_881_98393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 70,
    fill: "white",
    transform: "translate(-0.000366211 -0.000305176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExemptEntities);
export default __webpack_public_path__ + "static/media/exempt_entities.5a504da9654bde83642b68d2e40bb0ed.svg";
export { ForwardRef as ReactComponent };